import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  .ant-tabs {
    line-height: 1 !important;
  }
  .wrap-no-data {
    border: 1px solid #bcbcbc;
    border-top: none;
    margin-left: 1px;
  }

  .d-none {
    display: none;
  }
  .ant-select {
    min-width: 96%;

    .ant-select-arrow {
      right: 6px;
    }
  }

  .button-secondary {
    border: 1px solid rgba(37, 74, 127, 1);
    color: rgba(37, 74, 127, 1);
    background-color: #fff;
    margin-bottom: 0;
  }

  .button-add-row {
    border: 1px solid rgba(37, 74, 127, 1);
    color: rgba(37, 74, 127, 1);
    background-color: #fff;
    margin-bottom: 0;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 4px;
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    padding: 0;
  }

  .ant-select-selection-item {
    max-width: calc(100% - 16px) !important;
    min-width: calc(100% - 16px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .table-app-permission {
    padding-bottom: 60px;
    padding-top: 30px;
    background-color: #fff;

    table {
      width: 100%;
      border-radius: 8px 8px 0px 0px;
      overflow: hidden;
    }

    td,
    th {
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-collapse: collapse;
      text-align: center;
    }
    td,
    th {
      padding: 0;
      height: 50px;
    }
    th {
      background: #f0e6cc;
    }
    .even {
      background: #fbf8f0;
    }
    .odd {
      background: #fefcf9;
    }

    .table-head {
      background-color: rgba(237, 237, 237, 1);
    }

    .title-app-name {
      background-color: #c6ddfd;
    }
    .title-permission-all-app {
      background-color: #d6d6d6;
    }
    .title-confirm {
      background-color: rgba(219, 234, 255, 1);
    }
    .title-edit {
      background-color: rgba(206, 216, 249, 1);
    }
    .title-delete {
      background-color: #ffb6b4;
    }
    .title-app-action {
      background-color: rgba(214, 214, 214, 1);
    }
    .no-border-left {
      border-left: none;
    }
    .no-border-right {
      border-right: none;
    }
    .no-border {
      border: none;
    }
    .no-border-top {
      border-top: none;
    }
    .border-right {
      border-right: 1px solid rgba(0, 0, 0, 0.15);
    }
    .border-left {
      border-left: 1px solid rgba(0, 0, 0, 0.15);
    }
    .width-action {
      width: 2.5%;
    }
    .width-title-1 {
      width: 6%;
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    }
    .width-title-2 {
      width: 9%;
    }
  }

  .trash-icon {
    cursor: pointer;
  }
  .table-app-permission td.width-title-2,
  .table-app-permission th,
  .ant-select,
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    min-height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    height: auto;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    line-height: 1 !important;
  }
  .table-app-permission td,
  .table-app-permission th {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    line-height: 1 !important;
  }
  .table-app-permission {
    td {
      height: ${({ text_scale }) =>
        `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
      &.width-title-2 {
        height: ${({ text_scale }) =>
          `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
      }
    }
  }
  .ant-select-selection-item-content,
  .ant-select-multiple .ant-select-selection-item-remove {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
`;
